import { render, staticRenderFns } from "./PriorityMark.vue?vue&type=template&id=1fdb36d6&scoped=true&"
import script from "./PriorityMark.vue?vue&type=script&lang=js&"
export * from "./PriorityMark.vue?vue&type=script&lang=js&"
import style0 from "./PriorityMark.vue?vue&type=style&index=0&id=1fdb36d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb36d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdb36d6')) {
      api.createRecord('1fdb36d6', component.options)
    } else {
      api.reload('1fdb36d6', component.options)
    }
    module.hot.accept("./PriorityMark.vue?vue&type=template&id=1fdb36d6&scoped=true&", function () {
      api.rerender('1fdb36d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/PriorityMark.vue"
export default component.exports